import React from 'react'

export function ReportsIcon (props) {
  return (
    <svg viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M6.5 14v4m5-8v8m5-13v13' stroke='currentColor' strokeWidth={3} />
      <rect
        x={2}
        y={2}
        width={19}
        height={19}
        rx={1}
        stroke='currentColor'
        strokeWidth={2}
      />
    </svg>
  )
}
